let workerURL = require('./helpers/get-worker-url');
let url = new __parcel__URL__("zip-worker.ba2014d7.js");
module.exports = workerURL(url.toString(), url.origin, true);